const imagesLoaded = require('imagesloaded');

const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

const lerp = (a, b, n) => (1 - n) * a + n * b;

const calcWinsize = () => {
    return {width: window.innerWidth, height: window.innerHeight};
};

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const getMousePosition = e => {
    return {
        x : e.clientX,
        y : e.clientY
    };
};

const preloadImages = (selector) => {
    return new Promise((resolve, reject) => {
        imagesLoaded(document.querySelectorAll(selector), resolve);
    });
};

export { map, lerp, calcWinsize, getRandomNumber, getMousePosition, preloadImages };

export function loadJs(src) {
	return new Promise(function(resolve, reject) {
		const script = document.createElement('script')
		script.type = 'text/javascript';
		script.onload = resolve;
		script.onerror = reject;
		script.src = src;
		document.head.append(script);
	});
}